import { HuggyConfig } from '~/types/telelaudo'

export const useChatWidgets = () => {
  // const { user } = storeToRefs(useAuthStore())
  // const indecxInitialized = false

  // Inicializa widget IndeCX conforme a rota e o ambiente (porta da versão anterior)
  // const initIndeCX = () => {
  //   if (!import.meta.client || indecxInitialized) return

  //   const isRadiologista = user.value?.idmedico ? true : false
  //   const cfg = isRadiologista ? IndeCXRadiologista : IndeCXCliente

  //   if (!user.value?.email) return
  //   if (!Object.prototype.hasOwnProperty.call(window, 'IndeCX')) return

  //   if (cfg.key && cfg.action && cfg.indicators) {
  //     indecxInitialized = true
  //     window.IndeCX!({
  //       key: cfg.key,
  //       action: cfg.action,
  //       name: user.value?.name,
  //       email: user.value?.email,
  //       indicators: cfg.indicators
  //     })
  //   }
  // }

  // Carrega o script IndeCX e inicializa
  // const initChatWidgets = () => {
  //   if (!import.meta.client) return

  //   if (document.querySelector('script[src="https://indecx-widget.s3.amazonaws.com/widget.js"]')) {
  //     initIndeCX()
  //     return
  //   }

  //   const script = document.createElement('script')
  //   script.src = 'https://indecx-widget.s3.amazonaws.com/widget.js'
  //   script.onload = () => initIndeCX()
  //   script.onerror = () => console.error('Erro ao carregar script do IndeCX')
  //   document.head.appendChild(script)
  // }

  const initHuggy = () => {
    if (!import.meta.client)
      return
    if (window.Huggy)
      return
    console.log('Carregando script do Huggy...')
    const script = document.createElement('script')
    script.src = 'https://js.huggy.chat/widget.min.js'
    script.onload = () => {
      if (!window.Huggy) {
        console.error('[Huggy] não disponível')
        return
      }
      window.Huggy.init(HuggyConfig)
      // initChatWidgets()
    }
    script.onerror = () => console.error('[Huggy] falha ao carregar widget.min.js')
    document.head.appendChild(script)
  }

  return {
    initHuggy
  }
}
